import { Component, computed, input } from '@angular/core';
import { FieldTree, FormField } from '@angular/forms/signals';
import { TimePickerValue } from '@app/shared/types/models/shared/time-picker-value';
import { UiTimePickerComponent } from '@app/shared/ui/time-picker/ui-time-picker.component';
import { formatTime } from '@app/shared/utils/time-utils';
import { TranslatePipe } from '@ngx-translate/core';
import { ManualDurationKey, ManualDurationsModel, manualDurationsTotalSeconds } from '../time-report-form.types';

interface ManualDurationField {
  readonly name: ManualDurationKey;
  readonly labelKey: string;
  readonly field: FieldTree<TimePickerValue>;
}

const DURATION_FIELD_CONFIG: readonly Omit<ManualDurationField, 'field'>[] = [
  {
    name: 'standardHoursDuration',
    labelKey: 'time-report-hour-type-ordinary-hours'
  },
  {
    name: 'bankHoursDuration',
    labelKey: 'time-report-hour-type-bank_plus'
  },
  {
    name: 'overtime50Duration',
    labelKey: 'time-report-hour-type-overtime_50'
  },
  {
    name: 'overtime100Duration',
    labelKey: 'time-report-hour-type-overtime_100'
  }
];

@Component({
  selector: 'proffeo-manual-hours-duration-fields',
  templateUrl: './manual-hours-duration-fields.component.html',
  imports: [FormField, UiTimePickerComponent, TranslatePipe]
})
export class ManualHoursDurationFieldsComponent {
  protected readonly durationFields = computed((): ManualDurationField[] => {
    const durations = this.durations();
    return DURATION_FIELD_CONFIG.map(field => ({ ...field, field: durations[field.name] }));
  });
  protected readonly totalDurationLabel = computed(() =>
    formatTime(manualDurationsTotalSeconds(this.durations()().value()))
  );

  public readonly durations = input.required<FieldTree<ManualDurationsModel>>();
  public readonly minuteStep = input<number>(1);
}
